(self.PREFERRED_SOURCE = self.PREFERRED_SOURCE || []).push(
  function (preferredSource) {
    preferredSource.init({
      theme: 'light',
      lang: 'en'
    });

    const button = document.querySelector(
      '#google-preferred-source-btn'
    );

    if (!button) return;

    button.addEventListener('click', function (event) {
      event.preventDefault();

      preferredSource.addPreferredSource();
    });
  }
);
